import React, { FC } from 'react';
import { Modal } from '@eika/modal';
import { ModalDialogProps } from '@eika/modal/src/ModalDialogTypes';
import { RichIconTypes } from '@eika/rich-icon';
import { StandardButton } from '@eika/button';
import Card from '@eika/card/src/Card';
import safeArray from '../../util/SafeArray';

type CantChangeProfileModalProps = ModalDialogProps & {
    reasons?: string[][];
};

const CantChangeProfileModal: FC<CantChangeProfileModalProps> = ({ onClose, open, reasons }) => {
    return (
        <Modal onClose={onClose} open={open}>
            <Card
                title="Du kan desverre ikke endre spareprofil akkurat nå"
                isModal
                icon={RichIconTypes.HAAND_HEIHEI}
                className="cant-change-profile-modal"
            >
                <div>
                    {safeArray(reasons).map((reasonParagraphs: string[], i) => (
                        <div className="paragraph" key={i}>
                            {reasonParagraphs.map((paragraph: string) => (
                                <article className="paragraph" key={paragraph}>
                                    {paragraph}
                                </article>
                            ))}
                        </div>
                    ))}
                </div>
                <StandardButton size="large" buttonType="positive" onClick={onClose}>
                    OK
                </StandardButton>
            </Card>
        </Modal>
    );
};

export default CantChangeProfileModal;
